export function capitalizeFirstLetter(str) {
  return str[0].toUpperCase() + str.slice(1);
}

export function getMediaUrl(mediaUrl) {
  return process.env.NODE_ENV === 'production'
    ? window.dataWP.config.endpoints.app_url.replace(/\/$/, '') + mediaUrl
    : mediaUrl;
}

export function sendPageViewEvent(title = ''){
  const name = 'pageview';
  const data = {
    page: window.location.pathname + window.location.search,
    title
  };

  if(window.ga) {
    window.ga('send', name, data);
  }

  if(window.amplitude) {
    window.amplitude.getInstance().logEvent(name, data);
  }
}
